/* =========================================================================
   Vico Custom Cart Drawer  (replaces UpCart)
   Self-contained. Uses Shopify Cart AJAX API. No dependencies.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-vcd]');
  if (!root) return;

  var cfgEl = document.querySelector('[data-vcd-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }

  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  // ---- element refs -------------------------------------------------------
  var el = {
    overlay: root.querySelector('[data-vcd-overlay]'),
    drawer: root.querySelector('[data-vcd-drawer]'),
    count: root.querySelector('[data-vcd-count]'),
    scroll: root.querySelector('[data-vcd-scroll]'),
    items: root.querySelector('[data-vcd-items]'),
    empty: root.querySelector('[data-vcd-empty]'),
    footer: root.querySelector('[data-vcd-footer]'),
    progress: root.querySelector('[data-vcd-progress]'),
    progressMsg: root.querySelector('[data-vcd-progress-msg]'),
    bar: root.querySelector('[data-vcd-bar]'),
    nodeShip: root.querySelector('[data-vcd-node="ship"]'),
    nodeGift: root.querySelector('[data-vcd-node="gift"]'),
    recs: root.querySelector('[data-vcd-recs]'),
    recsTrack: root.querySelector('[data-vcd-recs-track]'),
    addons: root.querySelector('[data-vcd-addons]'),
    addonsTrack: root.querySelector('[data-vcd-addons-track]'),
    checkout: root.querySelector('[data-vcd-checkout]'),
    checkoutText: root.querySelector('[data-vcd-checkout-text]'),
    discountInput: root.querySelector('[data-vcd-discount-input]'),
    discountApply: root.querySelector('[data-vcd-discount-apply]'),
    discountMsg: root.querySelector('[data-vcd-discount-msg]'),
    applied: root.querySelector('[data-vcd-applied]'),
    savingsRow: root.querySelector('[data-vcd-savings-row]'),
    savings: root.querySelector('[data-vcd-savings]'),
    subtotal: root.querySelector('[data-vcd-subtotal]'),
    giftPicker: root.querySelector('[data-vcd-giftpicker]'),
    giftHeading: root.querySelector('[data-vcd-gift-heading]'),
    giftGrid: root.querySelector('[data-vcd-gift-grid]')
  };

  var state = { cart: null, busy: false, syncingGift: false, opened: false };

  // free-gift variant ids (customer picks one)
  var giftIds = (CFG.giftVariantIds || []).filter(Boolean);
  var giftIdSet = {};
  giftIds.forEach(function (id) { giftIdSet[id] = true; });

  // ---- helpers ------------------------------------------------------------
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var format = CFG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var value = '', match = format.match(placeholder);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    // strip any HTML the shop money_format may include (e.g. <span class="money">)
    return format.replace(placeholder, value).replace(/<[^>]*>/g, '');
  }

  function internalPost(url, body) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function internalGet(url) {
    return origFetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // ---- compare-at (sale) lookup -------------------------------------------
  // cart.js doesn't include compare_at_price, so fetch product data once per product
  var compareAtMap = {};      // variant_id -> compare_at price (cents)
  var compareAtPending = {};  // handle -> true while a fetch is in flight
  function ensureCompareAt(cart) {
    if (!cart || !cart.items || !origFetch) return Promise.resolve();
    var handles = {};
    cart.items.forEach(function (it) {
      if (it.variant_id in compareAtMap) return;
      if (it.handle && !compareAtPending[it.handle]) handles[it.handle] = true;
    });
    var list = Object.keys(handles);
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(function (h) {
      compareAtPending[h] = true;
      return origFetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          (p.variants || []).forEach(function (v) { compareAtMap[v.id] = v.compare_at_price || 0; });
          render();                               // show this product's strike as soon as it loads
        })
        .catch(function () { delete compareAtPending[h]; });  // failed -> allow a retry next time
    }));
  }
  // reference ("was") line price = higher of the normal line price or the compare-at price
  function referenceLine(it) {
    var ref = it.original_line_price;
    var ca = compareAtMap[it.variant_id] || 0;
    if (ca && ca * it.quantity > ref) ref = ca * it.quantity;
    return ref;
  }
  // total the customer saves across the cart (sales + discounts), excluding free gifts
  function totalSavings(cart) {
    if (!cart || !cart.items) return 0;
    var saved = 0;
    // compare-at ("sale") markdown only, measured against the pre-discount line price
    cart.items.forEach(function (it) {
      if (giftIdSet[it.id]) return;
      var ca = compareAtMap[it.variant_id] || 0;
      var ref = ca * it.quantity;
      if (ref > it.original_line_price) saved += ref - it.original_line_price;
    });
    // plus every discount Shopify applied (codes, automatic, line-level) — covers
    // order-level codes that don't reduce the individual line price in cart.js
    saved += cart.total_discount || 0;
    return saved;
  }

  // qualifying total = everything except any free-gift line
  function qualifyingTotal(cart) {
    if (!cart) return 0;
    var total = 0;
    cart.items.forEach(function (it) {
      if (giftIdSet[it.id]) return;
      total += it.final_line_price;
    });
    return total;
  }
  function giftLinesIn(cart) {
    return (cart && cart.items ? cart.items : []).filter(function (i) { return giftIdSet[i.id]; });
  }

  function idsInCart(cart) {
    var set = {};
    (cart ? cart.items : []).forEach(function (it) { set[it.id] = true; });
    return set;
  }

  // ---- open / close -------------------------------------------------------
  function open() {
    el.overlay.classList.add('is-open');
    el.drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    state.opened = true;
    // give the scroll area focus so trackpad/wheel scrolling works without a click
    try { el.scroll.focus({ preventScroll: true }); } catch (e) { try { el.scroll.focus(); } catch (e2) {} }
    refresh();
  }
  function close() {
    el.overlay.classList.remove('is-open');
    el.drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    state.opened = false;
  }

  // ---- rendering ----------------------------------------------------------
  function render() {
    var cart = state.cart;
    var empty = !cart || cart.item_count === 0;

    el.count.textContent = cart ? '• ' + cart.item_count : '';
    el.empty.classList.toggle('vcd-hide', !empty);
    el.footer.classList.toggle('vcd-hide', empty);
    if (el.progress) el.progress.classList.toggle('vcd-hide', empty);

    renderItems(cart);
    if (!empty) {
      renderProgress(cart);
      renderGiftPicker(cart);
      renderRails(cart);
    } else {
      if (el.recs) el.recs.classList.add('vcd-hide');
      if (el.addons) el.addons.classList.add('vcd-hide');
      if (el.giftPicker) el.giftPicker.classList.add('vcd-hide');
    }
    updateCheckout(cart);
    updateSummary(cart);
    renderApplied(cart);
    syncThemeCount(cart);
    if (window.requestAnimationFrame) requestAnimationFrame(updateAllArrows);
  }

  function renderItems(cart) {
    if (!cart) { el.items.innerHTML = ''; return; }
    // order-level discount (e.g. a code) isn't applied to each line in cart.js,
    // so spread it across the items in proportion to each line's price.
    var itemsSubtotal = cart.items_subtotal_price || 0;
    if (!itemsSubtotal) { cart.items.forEach(function (it) { itemsSubtotal += it.final_line_price; }); }
    var orderDisc = Math.max(0, itemsSubtotal - (cart.total_price || itemsSubtotal));
    var html = '';
    cart.items.forEach(function (it) {
      var isGift = !!giftIdSet[it.id];
      var img = it.image ? it.image.replace(/(\.[^.\/]*)?(\?|$)/, '_120x120$1$2') : '';
      // this line's price after its share of the order-level discount
      var orderShare = (itemsSubtotal > 0 && orderDisc > 0) ? Math.round(it.final_line_price / itemsSubtotal * orderDisc) : 0;
      var newLine = it.final_line_price - orderShare;
      var refL = referenceLine(it);
      var priceBlock;
      if (isGift || newLine === 0) {
        priceBlock = '<span class="vcd-item-free">FREE</span>';
      } else if (refL > newLine) {
        priceBlock = '<span class="vcd-was">' + formatMoney(refL) + '</span>' +
          formatMoney(newLine) +
          '<span class="vcd-save">Save ' + formatMoney(refL - newLine) + '</span>';
      } else {
        priceBlock = formatMoney(newLine);
      }
      var qtyControl = isGift
        ? '<span class="vcd-item-free">Gift</span>'
        : '<div class="vcd-qty">' +
            '<button type="button" data-vcd-dec="' + esc(it.key) + '" aria-label="Decrease">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-vcd-inc="' + esc(it.key) + '" aria-label="Increase">+</button>' +
          '</div>';
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<p class="vcd-item-variant">' + esc(it.variant_title) + '</p>' : '';
      html +=
        '<div class="vcd-item" data-key="' + esc(it.key) + '">' +
          '<img class="vcd-item-img" src="' + esc(img) + '" alt="" loading="lazy">' +
          '<div class="vcd-item-body">' +
            '<div class="vcd-item-top">' +
              '<div><p class="vcd-item-title">' + esc(it.product_title) + '</p>' + variant + '</div>' +
              '<button class="vcd-item-remove" data-vcd-remove="' + esc(it.key) + '" aria-label="Remove">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 6h18M8 6V4h8v2m-9 0 1 14h10l1-14"/></svg></button>' +
            '</div>' +
            '<div class="vcd-item-bottom">' + qtyControl +
              '<div class="vcd-price">' + priceBlock + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    el.items.innerHTML = html;
  }

  function renderProgress(cart) {
    if (!el.progress || !CFG.enableProgress) return;
    var q = qualifyingTotal(cart);
    var ship = CFG.shippingThreshold || 0;
    var gift = CFG.enableGift ? (CFG.giftThreshold || 0) : 0;
    var reachedShip = ship > 0 && q >= ship;
    var reachedGift = CFG.enableGift && gift > 0 && q >= gift;

    // node positions
    if (el.nodeShip) el.nodeShip.style.left = (CFG.enableGift ? '50%' : '100%');
    if (el.nodeShip) el.nodeShip.style.position = 'absolute';
    if (el.nodeShip) el.nodeShip.style.transform = 'translateX(-50%)';
    if (el.nodeGift) { el.nodeGift.style.left = '100%'; el.nodeGift.style.position = 'absolute'; el.nodeGift.style.transform = 'translateX(-50%)'; }

    // fill
    var fill = 0;
    if (CFG.enableGift && gift > 0) {
      if (q >= gift) fill = 100;
      else if (ship > 0 && q >= ship) fill = 50 + ((q - ship) / (gift - ship)) * 50;
      else if (ship > 0) fill = (q / ship) * 50;
    } else if (ship > 0) {
      fill = Math.min(q / ship, 1) * 100;
    }
    el.bar.style.width = Math.max(0, Math.min(100, fill)) + '%';

    if (el.nodeShip) el.nodeShip.classList.toggle('is-reached', reachedShip);
    if (el.nodeGift) el.nodeGift.classList.toggle('is-reached', reachedGift);

    // message (prioritise the next unmet milestone)
    var msg = '', celebrate = false;
    if (CFG.enableGift && gift > 0 && !reachedGift) {
      if (!reachedShip && ship > 0) {
        msg = CFG.shipMsgBefore.replace('[amount]', formatMoney(ship - q));
      } else {
        msg = CFG.giftMsgBefore.replace('[amount]', formatMoney(gift - q));
      }
    } else if (CFG.enableGift && reachedGift) {
      msg = CFG.giftMsgReached; celebrate = true;
    } else if (ship > 0 && !reachedShip) {
      msg = CFG.shipMsgBefore.replace('[amount]', formatMoney(ship - q));
    } else {
      msg = CFG.shipMsgReached; celebrate = true;
    }
    el.progressMsg.innerHTML = msg.replace(/(€?[\d.,]+)(?=\s|$)/, '<span class="vcd-amt">$1</span>');
    el.progressMsg.classList.toggle('vcd-celebrate', celebrate);
  }

  // ---- free-gift picker ---------------------------------------------------
  function giftCardHTML(p) {
    return '<div class="vcd-gift-card">' +
      '<img src="' + esc(p.image) + '" alt="" loading="lazy">' +
      '<p class="vcd-gift-title">' + esc(p.title) + '</p>' +
      '<p class="vcd-gift-free">Free</p>' +
      '<button class="vcd-gift-add" data-vcd-addgift="' + p.id + '">Add my free gift</button>' +
    '</div>';
  }

  function renderGiftPicker(cart) {
    if (!el.giftPicker) return;
    var gifts = CFG.giftVariants || [];
    var q = qualifyingTotal(cart);
    var qualifies = CFG.enableGift && CFG.giftThreshold && q >= CFG.giftThreshold;
    var hasGift = giftLinesIn(cart).length > 0;
    if (qualifies && !hasGift && gifts.length) {
      el.giftHeading.textContent = CFG.giftPickerHeading || 'Pick your free gift';
      el.giftGrid.innerHTML = gifts.map(giftCardHTML).join('');
      el.giftPicker.classList.remove('vcd-hide');
    } else {
      el.giftPicker.classList.add('vcd-hide');
    }
  }

  function cardHTML(p, cls) {
    var img = p.image ? p.image : '';
    var priceHtml;
    if (p.compare_at && p.compare_at > p.price) {
      priceHtml = '<span class="vcd-was">' + formatMoney(p.compare_at) + '</span>' +
        formatMoney(p.price) + ' <span class="vcd-save">Save ' + formatMoney(p.compare_at - p.price) + '</span>';
    } else {
      priceHtml = formatMoney(p.price);
    }
    return '<div class="vcd-card ' + (cls || '') + '">' +
      '<img class="vcd-card-img" src="' + esc(img) + '" alt="" loading="lazy">' +
      '<div class="vcd-card-body">' +
        '<p class="vcd-card-title">' + esc(p.title) + '</p>' +
        '<p class="vcd-card-price">' + priceHtml + '</p>' +
        '<button class="vcd-add-btn" data-vcd-add="' + p.id + '">Add</button>' +
      '</div></div>';
  }

  function renderRails(cart) {
    var inCart = idsInCart(cart);
    var shown = {}; // ids already shown in add-ons, so recs don't repeat them
    var scent = CFG.enableScentRecs ? scentMatches(cart, inCart) : [];

    // ADD-ONS — same-scent matches first, then your manual add-on products
    if (el.addons && CFG.enableAddons) {
      var manualAddons = (CFG.addons || []).filter(function (p) { return p.available && !inCart[p.id]; });
      var seenA = {}, addonList = [];
      scent.concat(manualAddons).forEach(function (p) {
        if (!p || seenA[p.id] || inCart[p.id]) return;
        seenA[p.id] = true; addonList.push(p);
      });
      addonList = addonList.slice(0, CFG.recLimit || 6);
      if (addonList.length) {
        el.addonsTrack.innerHTML = addonList.map(function (p) { return cardHTML(p, ''); }).join('');
        el.addons.classList.remove('vcd-hide');
        updateArrows(el.addons.querySelector('.vcd-rail-wrap'));
        addonList.forEach(function (p) { shown[p.id] = true; });
      } else {
        el.addons.classList.add('vcd-hide');
      }
    }

    // RECOMMENDATIONS — manual / auto (scent pairing now lives in add-ons)
    if (!el.recs) return;
    var source = CFG.recSource || 'both';
    var manual = (CFG.manualRecs || []).filter(function (p) { return p.available && !inCart[p.id] && !shown[p.id]; });

    function paint(base) {
      var seen = {}, list = [];
      (base || []).forEach(function (p) {
        if (!p || seen[p.id] || inCart[p.id] || shown[p.id]) return;
        seen[p.id] = true; list.push(p);
      });
      list = list.slice(0, CFG.recLimit || 6);
      if (list.length) {
        el.recsTrack.innerHTML = list.map(function (p) { return cardHTML(p, ''); }).join('');
        el.recs.classList.remove('vcd-hide');
        updateArrows(el.recs.querySelector('.vcd-rail-wrap'));
      } else {
        el.recs.classList.add('vcd-hide');
      }
    }

    if (source === 'manual') {
      paint(manual);
    } else if (source === 'auto') {
      fetchAuto(cart, inCart).then(paint);
    } else { // both
      if (manual.length) paint(manual);
      else fetchAuto(cart, inCart).then(paint);
    }
  }

  function fetchAuto(cart, inCart) {
    if (!cart || !cart.items.length) return Promise.resolve([]);
    var pid = cart.items[0].product_id;
    var url = '/recommendations/products.json?product_id=' + pid + '&limit=' + (CFG.recLimit || 6) + '&intent=related';
    return internalGet(url).then(function (data) {
      var out = [];
      (data.products || []).forEach(function (prod) {
        var v = null;
        for (var i = 0; i < prod.variants.length; i++) { if (prod.variants[i].available) { v = prod.variants[i]; break; } }
        if (!v || inCart[v.id]) return;
        out.push({
          id: v.id, title: prod.title, price: v.price,
          compare_at: v.compare_at_price || 0, available: true,
          url: prod.url, image: (prod.featured_image || (prod.images && prod.images[0]) || '')
        });
      });
      return out;
    }).catch(function () { return []; });
  }

  function updateCheckout(cart) {
    if (!cart) return;
    if (CFG.showSubtotalInButton && cart.item_count > 0) {
      el.checkoutText.textContent = CFG.checkoutText + '  •  ' + formatMoney(cart.total_price);
    } else {
      el.checkoutText.textContent = CFG.checkoutText;
    }
  }

  function updateSummary(cart) {
    if (!cart) return;
    var saved = totalSavings(cart);
    if (el.subtotal) {
      if (saved > 0) {
        el.subtotal.innerHTML = '<span class="vcd-was">' + formatMoney(cart.total_price + saved) + '</span>' + formatMoney(cart.total_price);
      } else {
        el.subtotal.textContent = formatMoney(cart.total_price);
      }
    }
    if (el.savingsRow) {
      if (saved > 0) {
        el.savingsRow.classList.remove('vcd-hide');
        if (el.savings) el.savings.textContent = '−' + formatMoney(saved);
      } else {
        el.savingsRow.classList.add('vcd-hide');
      }
    }
  }

  function syncThemeCount(cart) {
    if (!cart) return;
    document.querySelectorAll('.cart-link__count, [data-cart-item-count], .cart-link__bubble .cart-link__count')
      .forEach(function (n) { n.textContent = cart.item_count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
    });
    var si = document.getElementById('StickyItems');
    if (si) si.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    var ss = document.getElementById('StickySubtotal');
    if (ss) ss.textContent = formatMoney(cart.total_price);
  }

  // ---- cart operations ----------------------------------------------------
  function setBusy(b) {
    state.busy = b;
    el.scroll.classList.toggle('vcd-spin', b);
  }

  function refresh() {
    return internalGet('/cart.js').then(function (cart) {
      state.cart = cart;
      return syncGift(cart);
    }).then(function () {
      render();
      ensureCompareAt(state.cart).then(function () { render(); });
    }).catch(function () { render(); });
  }

  // keep the free gift valid: remove it if below threshold; never allow more than one
  function syncGift(cart) {
    if (state.syncingGift) return Promise.resolve();
    if (!CFG.enableGift || !CFG.giftThreshold || !giftIds.length) return Promise.resolve();
    var q = qualifyingTotal(cart);
    var giftLines = giftLinesIn(cart);
    var toRemove = [];
    if (q < CFG.giftThreshold) {
      toRemove = giftLines;                 // dropped below threshold -> remove the gift
    } else if (giftLines.length > 1) {
      toRemove = giftLines.slice(1);        // qualified but somehow >1 -> keep just one
    }
    if (!toRemove.length) return Promise.resolve();
    state.syncingGift = true;
    var chain = Promise.resolve();
    toRemove.forEach(function (it) {
      chain = chain.then(function () { return internalPost('/cart/change.js', { id: it.key, quantity: 0 }); });
    });
    return chain
      .then(function () { return internalGet('/cart.js'); })
      .then(function (c) { state.cart = c; })
      .catch(function () {})
      .then(function () { state.syncingGift = false; });
  }

  // customer claims a chosen free gift (only one allowed)
  function addGift(id) {
    if (!state.cart) return;
    setBusy(true);
    var existing = giftLinesIn(state.cart);
    var chain = Promise.resolve();
    existing.forEach(function (it) { chain = chain.then(function () { return internalPost('/cart/change.js', { id: it.key, quantity: 0 }); }); });
    chain
      .then(function () { return internalPost('/cart/add.js', { id: parseInt(id, 10), quantity: 1 }); })
      .then(function () { return refresh(); })
      .catch(function () {})
      .then(function () { setBusy(false); });
  }

  // products in the scent pool matching a scent already in the cart (by product name)
  function scentMatches(cart, inCart) {
    var pool = CFG.scentPool || [];
    var kws = (CFG.scentKeywords || []).filter(Boolean);
    if (!pool.length || !kws.length || !cart) return [];
    var cartScents = [];
    cart.items.forEach(function (it) {
      if (giftIdSet[it.id]) return;
      var title = (it.product_title || it.title || '').toLowerCase();
      kws.forEach(function (kw) {
        var k = kw.toLowerCase();
        if (k && title.indexOf(k) !== -1 && cartScents.indexOf(k) === -1) cartScents.push(k);
      });
    });
    if (!cartScents.length) return [];
    var out = [];
    pool.forEach(function (p) {
      if (!p.available || inCart[p.id]) return;
      var t = (p.title || '').toLowerCase();
      for (var i = 0; i < cartScents.length; i++) {
        if (t.indexOf(cartScents[i]) !== -1) { out.push(p); break; }
      }
    });
    return out;
  }

  function changeQty(key, qty) {
    setBusy(true);
    internalPost('/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) { state.cart = cart; return syncGift(cart); })
      .then(function () { render(); })
      .catch(function () {})
      .then(function () { setBusy(false); });
  }

  function addVariant(id) {
    setBusy(true);
    internalPost('/cart/add.js', { id: parseInt(id, 10), quantity: 1 })
      .then(function () { return refresh(); })
      .catch(function () {})
      .then(function () { setBusy(false); });
  }

  // ---- discount codes -----------------------------------------------------
  // list the discount codes currently applied & valid for the cart
  function appliedCodes(cart) {
    var out = [];
    ((cart && cart.discount_codes) ? cart.discount_codes : []).forEach(function (d) {
      if (d && d.code && d.applicable !== false) out.push(d.code);
    });
    return out;
  }
  // render each applied code as a removable pill
  function renderApplied(cart) {
    if (!el.applied) return;
    var codes = appliedCodes(cart);
    if (!codes.length) { el.applied.classList.add('vcd-hide'); el.applied.innerHTML = ''; return; }
    el.applied.classList.remove('vcd-hide');
    el.applied.innerHTML = codes.map(function (c) {
      return '<span class="vcd-chip">' + esc(c) +
        '<button type="button" class="vcd-chip-x" data-vcd-remove-code="' + esc(c) + '" aria-label="Remove discount ' + esc(c) + '">&times;</button></span>';
    }).join('');
  }

  function applyDiscount() {
    var code = (el.discountInput.value || '').trim();
    if (!code) return;
    el.discountApply.disabled = true;
    // Cart AJAX API: apply discount codes via /cart/update.js
    internalPost('/cart/update.js', { discount: code })
      .then(function (cart) {
        state.cart = cart;
        render();
        ensureCompareAt(state.cart).then(function () { render(); });
        var applied = appliedCodes(cart).map(function (x) { return x.toLowerCase(); });
        el.discountMsg.classList.remove('vcd-hide');
        if (applied.indexOf(code.toLowerCase()) > -1) {
          el.discountInput.value = '';
          el.discountMsg.textContent = 'Discount applied ✓';
          el.discountMsg.style.color = '#1f9d55';
        } else {
          el.discountMsg.textContent = 'That code isn’t valid for your cart.';
          el.discountMsg.style.color = '#c0392b';
        }
      })
      .catch(function () {})
      .then(function () { el.discountApply.disabled = false; });
  }

  // remove one applied code (keep any others)
  function removeDiscount(code) {
    var remaining = appliedCodes(state.cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    internalPost('/cart/update.js', { discount: remaining.join(',') })
      .then(function (cart) {
        state.cart = cart;
        if (el.discountMsg) el.discountMsg.classList.add('vcd-hide');
        render();
        ensureCompareAt(state.cart).then(function () { render(); });
      })
      .catch(function () {});
  }

  // ---- external cart-change detection (theme quick-adds etc.) --------------
  var extTimer = null;
  function onExternalCartChange(opened) {
    clearTimeout(extTimer);
    extTimer = setTimeout(function () {
      refresh();
      if (opened) open();
    }, 250);
  }

  if (window.fetch) {
    var wrapped = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isInternal = false;
      // our own calls go through origFetch, so anything here is external
      var p = wrapped.apply(this, arguments);
      if (!isInternal && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        var isAdd = /\/cart\/add/.test(url);
        p.then(function (res) { try { if (res && res.ok) onExternalCartChange(isAdd); } catch (e) {} });
      }
      return p;
    };
  }

  // wrap XHR (theme uses jQuery.ajax -> XHR)
  (function () {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__vcdUrl = url || ''; return XO.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      if (self.__vcdUrl && /\/cart\/(add|change|update|clear)(\.js)?/.test(self.__vcdUrl)) {
        var isAdd = /\/cart\/add/.test(self.__vcdUrl);
        self.addEventListener('loadend', function () {
          if (self.status >= 200 && self.status < 300) onExternalCartChange(isAdd);
        });
      }
      return XS.apply(this, arguments);
    };
  })();

  // ---- event wiring -------------------------------------------------------
  // open triggers: cart icon / cart links
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '.js-drawer-open-cart, .site-nav__thumb-cart, .site-nav__link--cart, a[href="/cart"], a[href$="/cart"], a[href*="/cart?"], #StickyItems, #StickySubtotal'
    );
    if (trigger) {
      // don't hijack real checkout buttons
      if (trigger.getAttribute('name') === 'checkout') return;
      e.preventDefault();
      e.stopPropagation();
      open();
    }
  }, true);

  // intercept add-to-cart form submits (PDP, quick add, add-on forms)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
    e.preventDefault();
    e.stopPropagation();
    var fd = new FormData(form);
    setBusy(true);
    origFetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function () {})
      .then(function () { setBusy(false); });
  }, true);

  // internal drawer clicks
  root.addEventListener('click', function (e) {
    var t = e.target;
    var closeBtn = t.closest('[data-vcd-close]');
    if (closeBtn || t.hasAttribute('data-vcd-overlay')) { close(); return; }

    var inc = t.closest('[data-vcd-inc]');
    if (inc) { var k = inc.getAttribute('data-vcd-inc'); var it = findItem(k); if (it) changeQty(k, it.quantity + 1); return; }
    var dec = t.closest('[data-vcd-dec]');
    if (dec) { var k2 = dec.getAttribute('data-vcd-dec'); var it2 = findItem(k2); if (it2) changeQty(k2, it2.quantity - 1); return; }
    var rem = t.closest('[data-vcd-remove]');
    if (rem) { changeQty(rem.getAttribute('data-vcd-remove'), 0); return; }
    var sp = t.closest('[data-vcd-scroll-prev]');
    if (sp) { scrollRail(sp, -1); return; }
    var sn = t.closest('[data-vcd-scroll-next]');
    if (sn) { scrollRail(sn, 1); return; }
    var addg = t.closest('[data-vcd-addgift]');
    if (addg) { addGift(addg.getAttribute('data-vcd-addgift')); return; }
    var add = t.closest('[data-vcd-add]');
    if (add) { addVariant(add.getAttribute('data-vcd-add')); return; }
  });

  function scrollRail(btn, dir) {
    var wrap = btn.closest('.vcd-rail-wrap');
    if (!wrap) return;
    var track = wrap.querySelector('.vcd-rail-track');
    if (!track) return;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  }

  function updateArrows(wrap) {
    if (!wrap) return;
    var tr = wrap.querySelector('.vcd-rail-track');
    var prev = wrap.querySelector('[data-vcd-scroll-prev]');
    var next = wrap.querySelector('[data-vcd-scroll-next]');
    if (!tr) return;
    var max = tr.scrollWidth - tr.clientWidth - 2;
    var overflow = tr.scrollWidth > tr.clientWidth + 2;
    if (prev) prev.disabled = !overflow || tr.scrollLeft <= 2;
    if (next) next.disabled = !overflow || tr.scrollLeft >= max;
  }

  function updateAllArrows() {
    root.querySelectorAll('.vcd-rail-wrap').forEach(updateArrows);
  }

  // keep arrow enabled/disabled state in sync while scrolling
  root.querySelectorAll('.vcd-rail-track').forEach(function (tr) {
    tr.addEventListener('scroll', function () { updateArrows(tr.closest('.vcd-rail-wrap')); });
  });

  el.overlay.addEventListener('click', close);
  if (el.checkout) el.checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
  if (el.discountApply) el.discountApply.addEventListener('click', applyDiscount);
  if (el.discountInput) el.discountInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); } });
  if (el.applied) el.applied.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vcd-remove-code]');
    if (b) removeDiscount(b.getAttribute('data-vcd-remove-code'));
  });
  if (el.discountInput) el.discountInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.opened) close(); });

  function findItem(key) {
    if (!state.cart) return null;
    return state.cart.items.filter(function (i) { return i.key === key; })[0];
  }

  // expose a tiny API
  window.VicoCart = { open: open, close: close, refresh: refresh };

  // prime cart state (so header counts stay in sync) without opening
  refresh();
})();